import React, { useEffect, useState } from "react";
import * as db from '../cache/db';
import { photoKey } from '../cache/routePreCache';

const ImageWithToken = ({
  imageUrl,
  alt = "Image",
  user,
  className,
}) => {
  const [imgSrc, setImgSrc] = useState(null);

  useEffect(() => {
    let objectUrl = null;
    let didCancel = false;

    const fetchImage = async () => {
      if (!user || !imageUrl) return;

      try {
        // Cache-first: extract place reference from URL pattern /place/{ref}/photo
        const ref = imageUrl?.match(/\/place\/([^/]+)\/photo/)?.[1];
        if (ref) {
          const cached = await db.get(photoKey(ref));
          if (cached && !didCancel) {
            objectUrl = URL.createObjectURL(cached);
            setImgSrc(objectUrl);
            return;
          }
        }

        const headersObj = new Headers();
        const token = await user.getIdToken(false);
        if (token) headersObj.append("Authorization", `Bearer ${token}`);

        const response = await fetch(imageUrl, { headers: headersObj });
        if (!response.ok) throw new Error("Failed to fetch image");

        const blob = await response.blob();
        if (!didCancel) {
          objectUrl = URL.createObjectURL(blob);
          setImgSrc(objectUrl);
        }
      } catch (error) {
        if (!didCancel) console.error("Error fetching image:", error);
      }
    };

    fetchImage();

    return () => {
      didCancel = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [imageUrl, user]);

  return (imageUrl && user && imgSrc &&
    <img src={imgSrc} alt={alt} className={className} />
  );
};

export default React.memo(ImageWithToken);
